import { z } from "zod"

export const DEFAULT_BACKOFFICE_CONVERSATION_SALES_REPORT_TIME_ZONE = "Europe/Madrid"

const DateOnlySchema = z
  .string()
  .regex(/^\d{4}-\d{2}-\d{2}$/, {
    error: "Expected date in YYYY-MM-DD format",
  })
  .refine(
    (value) => {
      const [year, month, day] = value.split("-").map(Number)
      const date = new Date(Date.UTC(year ?? 0, (month ?? 0) - 1, day ?? 0))

      return (
        date.getUTCFullYear() === year &&
        date.getUTCMonth() === (month ?? 0) - 1 &&
        date.getUTCDate() === day
      )
    },
    {
      error: "Invalid date",
    },
  )

export const BackofficeConversationSalesReportExportFieldsSchema = z.object({
  companyId: z.string().transform(BigInt),
  from: DateOnlySchema,
  to: DateOnlySchema,
  timeZone: z.string().default(DEFAULT_BACKOFFICE_CONVERSATION_SALES_REPORT_TIME_ZONE),
})

export const BackofficeConversationSalesReportExportBodySchema =
  BackofficeConversationSalesReportExportFieldsSchema.refine((data) => data.from <= data.to, {
    path: ["to"],
    error: "The end date must be equal to or later than the start date",
  })
